/*
 * File Created: Wednesday, 7th December 2022 10:55:21 am
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2022 Addble Solutions Private Limited. All Rights Reserved.
 */

import React from "react";
// import Box from "@mui/material/Box";
import MuiButton, { type ButtonProps as MuiButtonProps } from "@mui/material/Button";
// import Typography from '@mui/material/Typography';
import { Colors } from "../constants/color";

interface ButtonProps extends MuiButtonProps {
  title: string;
  customIcon?: JSX.Element;
  href?: string;
  // onClick?: () => void;
}

function Button({
  title,
  // customIcon,
  href,
  ...rest
}: ButtonProps): JSX.Element {
  return (
    <MuiButton
      variant="outlined"
      // endIcon={customIcon}
      // onClick={onClick}
      sx={{
        borderRadius: 0,
        padding: "11.5px 15px",
        border: `1px solid ${Colors.fallow}`,
        color: "inherit",
        "&.MuiButtonBase-root:hover": {
          backgroundColor: Colors.fallow,
          border: `1px solid ${Colors.fallow}`,
        },
      }}
      {...rest}
    >
      {title}
    </MuiButton>
    // <Box
    //   sx={{
    //     width: 'fit-content',
    //     display: 'flex',
    //     alignItems: 'center',
    //     justifyContent: 'center',
    //     padding: '11.5px 15px',
    //     border: `1px solid ${Colors.fallow}`,
    //     '&:hover': {
    //       backgroundColor: Colors.fallow,
    //       color: Colors.white,
    //       cursor: 'pointer',
    //     },
    //   }}
    //   onClick={onClick}
    // >
    //   <Box
    //     component='a'
    //     href={href}
    //     sx={{
    //       display: 'flex',
    //       flexDirection: 'row',
    //       alignItems: 'center',
    //       // color: '#fff',
    //       color: 'inherit',
    //       textDecoration: 'none',
    //     }}
    //   >
    //     <Typography
    //       sx={{
    //         fontSize: { xs: '14px' },
    //         textTransform: 'uppercase',
    //       }}
    //     >
    //       {title}
    //     </Typography>
    //     {customIcon}
    //   </Box>
    // </Box>
  );
}

export default Button;
